import React from "react";
import { ReactComponent as LogoutIcon } from "@src/assets/svg/logout-icon.svg";
import { ReactComponent as QuestionMarkIcon } from "@src/assets/svg/question-mark-circle.svg";
import { ReactComponent as BrokenCubeIcon } from "@src/assets/svg/tt_broken_cube.svg";
import { ReactComponent as HypercubeIcon } from "@src/assets/svg/tt_hypercube.svg";
import { ReactComponent as GatewaysIcon } from "@src/assets/svg/gateways-icon.svg";
import { ReactComponent as SearchIcon } from "@src/assets/svg/tt_search.svg";
import { ReactComponent as SettingsIcon } from "@src/assets/svg/tt_settings.svg";
import { ReactComponent as UserIcon } from "@src/assets/svg/tt_user.svg";
import { ReactComponent as DevIcon } from "@src/assets/svg/tt_dev.svg";
import { ReactComponent as UsersIcon } from "@src/assets/svg/users-icon.svg";
import { ReactComponent as SolidSparklesIcon } from "@src/assets/svg/sparkles-solid.svg";
import { ReactComponent as MachineIcon } from "@src/assets/svg/machines-icon.svg";
import { ReactComponent as DisconnectVpnIcon } from "@src/assets/svg/disconnect-vpn-icon.svg";
import { ReactComponent as FilterIcon } from "@src/assets/svg/filter-icon.svg";
import { ReactComponent as VpnFilterIcon } from "@src/assets/svg/machines-filter-icon.svg";
import { ReactComponent as QuestionMarkInfoBlueIcon } from "@src/assets/svg/question-mark-info-blue.svg";
import { ReactComponent as ArrowIcon } from "@src/assets/svg/arrow.svg";
import { ReactComponent as VpnRemoteSupport } from "@src/assets/svg/machines-remote-support.svg";
import { ReactComponent as ChatSparkleIcon } from "@src/assets/svg/chat-support-sparkle.svg";
import { ReactComponent as SupportTicketIcon } from "@src/assets/svg/request-remote-access-user-icon.svg";
import { ReactComponent as TicketIcon } from "@src/assets/svg/ticket-icon.svg";
import { ReactComponent as AlarmNotificationIcon } from "@src/assets/svg/alarm-notification-icon.svg";
import { ReactComponent as NotificationIcon } from "@src/assets/svg/notification-icon.svg";
import { ReactComponent as InfoIcon } from "@src/assets/svg/info-icon-blue.svg";
import { ReactComponent as FactoryDashboardIcon } from "@src/assets/svg/factory-dashboard-icon.svg";
import { ReactComponent as DashboardBuilderIcon } from "@src/assets/svg/dashboard-builder-icon.svg";
import { ReactComponent as DashboardsIcon } from "@src/assets/svg/dashboards-icon.svg";
import { ReactComponent as AdminPanelIcon } from "@src/assets/svg/admin-panel-icon.svg";

import styles from "./icon.module.scss";

interface IconComponentProps {
  name?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const Icon = ({ name, width, height, color }: IconComponentProps) => {
  const iconMap: Record<string, React.ElementType> = {
    logout: LogoutIcon,
    question_mark: QuestionMarkIcon,
    sparkles_solid: SolidSparklesIcon,
    tt_broken_cube: BrokenCubeIcon,
    tt_hypercube: HypercubeIcon,
    gateways_icon: GatewaysIcon,
    tt_search: SearchIcon,
    tt_settings: SettingsIcon,
    tt_user: UserIcon,
    tt_dev: DevIcon,
    users: UsersIcon,
    vpn_remote_support: VpnRemoteSupport,
    machines_icon: MachineIcon,
    disconnect_vpn: DisconnectVpnIcon,
    filter: FilterIcon,
    vpn_filter: VpnFilterIcon,
    question_mark_info_blue: QuestionMarkInfoBlueIcon,
    arrow: ArrowIcon,
    chat: ChatSparkleIcon,
    support_ticket: SupportTicketIcon,
    ticket_icon: TicketIcon,
    alarm_notification: AlarmNotificationIcon,
    info_icon: InfoIcon,
    notification_icon: NotificationIcon,
    factory_dashboard_icon: FactoryDashboardIcon,
    dashboard_builder_icon: DashboardBuilderIcon,
    dashboard_icon: DashboardsIcon,
    admin_panel_icon: AdminPanelIcon,
  };

  const IconComponent = iconMap[name || ""] || "div";

  return (
    <span
      className={styles["icon-wrapper"]}
      style={{
        width: width ? `${width}px` : "",
        height: height ? `${height}px` : "",
        color: color ?? "inherit",
      }}
    >
      <IconComponent width={width} height={height} />
    </span>
  );
};
